import React from 'react'
import SiteGrid from "../ui/SiteGrid"
import { AppInput } from "../ui/AppInputs"
import { useState } from "react"
import { validateEmail } from "app/utils/generalUtils"
import AppButton from "../ui/AppButton"

export default function Subscribe() {

  const [email, setEmail] = useState('')

  const handleSubscribe = () => {
    if (validateEmail(email)) {
      alert('Thank you for subscribing!')
    } else {
      alert('Please enter a valid email address')
    }
  }

  return (
    <div className="subscribe-section home-section">
      <SiteGrid className="subscribe-flex">
        <div className="left">
          <h5>Subscribe to our newsletter to stay in the loop</h5>
        </div>
        <div className="right">
          <AppInput
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyUp={(e) => e.key === 'Enter' && handleSubscribe()}
            subtext={
              <AppButton
                label="Subscribe"
                onClick={handleSubscribe}
                buttonType="outlineWhiteBtn animate"
              />
            }
          />
        </div>
      </SiteGrid>
    </div>
  )
}
